export default {
	init: () => {
		console.log('a')
		document.querySelector('.js-add-donation').addEventListener('click', () => {
			console.log('b')
			document.querySelector('.js-donation-form').submit();
		})
	}
}